import { render, staticRenderFns } from "./MaxDiff.vue?vue&type=template&id=2da5edba&scoped=true"
import script from "./MaxDiff.vue?vue&type=script&lang=js"
export * from "./MaxDiff.vue?vue&type=script&lang=js"
import style0 from "./MaxDiff.vue?vue&type=style&index=0&id=2da5edba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da5edba",
  null
  
)

export default component.exports